import React from 'react';
import { getMessage } from '@tcc/i18n';
import { getCrops } from '../../../../../selectors';
import { Crop } from '../../../../../types';
import { useAppSelector } from '../../../../../utils';
import { ScoutingFormListItem } from '../ScoutingFormListItem/ScoutingFormListItem';
import styles from '../scoutingForm.css';
import { ScoutingFormIsEditingTitle } from '../ScoutingFormIsEditingTitle/ScoutingFormIsEditingTitle';

export type CropsSelectionProps = {
  selectedCrop?: Crop;
  onSelection: (selectedCrop: Crop) => void;
  title: string;
  done: () => void;
};

export const CropsSelectionView = ({ title, done, selectedCrop, onSelection }: CropsSelectionProps) => {
  const state = useAppSelector(state => state);
  const crops = Object.values(getCrops(state)).filter(crop => !!crop) as Crop[];

  return <>
    <ScoutingFormIsEditingTitle
      title={title}
      subtitle={getMessage('crop')}
      leftLabel={getMessage('done')}
      onLeft={done}
    />
    <div className={`${styles.enhancedScoutingContent} ${styles.enhancedScoutingDetailsContent}`}>
      {crops.map(crop =>
        <ScoutingFormListItem
          key={crop.code}
          onClick={() => onSelection(crop)}
          selected={selectedCrop && crop.code === selectedCrop.code}>
          {crop.name}
        </ScoutingFormListItem>
      )}
    </div>
  </>
};
